<template>
  <div>
    <div class="modal modal--welcomeback"
         id="jackpot_prizes">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header modal_ti_header"></div>
        <div class="modal__body modal_ti_header">
          <h1>{{ getTranslations.home_modals_jackpot_prizes_title }}</h1>
          <p>{{ getTranslations.home_modals_jackpot_prizes_every_day }}</p>
          <img class="modal_icon_alert" src="static/images/icon-howitworks-jackpot.png">
          <h1>{{ getTranslations.home_modals_jackpot_prizes_how_to_win }}</h1>
          <ul>
            <li>{{ getTranslations.home_modals_jackpot_prizes_list_item1 }}</li>
          </ul><br>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'jackpot-prizes',
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#jackpot_prizes').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/JackpotPrizes.vue